/*
 *
 * App reducer
 *
 */

import {
  SET_AUTH_TOKEN,
  SET_USER,
} from './constants';

import {
  PUT_ACCOUNT_SUCCESS
} from 'containers/AccountPage/constants'

const initialState = {
  user: {
    authToken: '',
    company: null,
    enterprise_admins: null,
    id: null,
    if_lite_photographer: null,
    if_unlimitied_photographer: null,
    permission_role: "",
    name: '',
    email: '',
    role: '',
    unconfirmedEmail: null
  },
};

function appReducer(state = initialState, action) {
  switch (action.type) {
    case SET_AUTH_TOKEN:
      return {
        ...state,
        user: {
          ...state.user,
          authToken: action.payload
        }
      };
    case SET_USER:
    case PUT_ACCOUNT_SUCCESS:
    case 'PLAN_SUBSCRIPTION_SUCCESS':
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload
        }
      };
    default:
      return state;
  }
}

export default appReducer;



// WEBPACK FOOTER //
// ./src/containers/App/reducer.js